import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import esJSON from './translations/es';
import frJSON from './translations/fr';
import aeJSON from './translations/ae';
import zhJSON from './translations/zh';

import grJSON from './translations/gr';
import nlJSON from './translations/nl';
import bgJSON from './translations/bg';
import deJSON from './translations/de';
import enJSON from './translations/en';

const resources = {
  es: { translation: esJSON },
  fr: { translation: frJSON },
  ae: { translation: aeJSON },
  cn: { translation: zhJSON },
  de: { translation: deJSON },
  gr: { translation: grJSON },
  en: { translation: enJSON },
  bg: { translation: bgJSON },
  nl: { translation: nlJSON }
};

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    keySeparator: false,
    lng: 'en',
    fallbackLng: 'en',
    react: {
      useSuspense: true
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
